module.exports = __webpack_public_path__ + "img/pause-btn.78b65614.svg";